import React from 'react';
import { useNavigate } from 'react-router';
import { useTranslation } from '../../../../shared/i18n';

export const WelcomePage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const features = [
    {
      key: 'learning',
      icon: 'bi-controller',
      color: 'primary',
    },
    {
      key: 'tracking',
      icon: 'bi-graph-up',
      color: 'success',
    },
    {
      key: 'safe',
      icon: 'bi-shield-check',
      color: 'info',
    },
  ];

  return (
    <div className="min-vh-100 bg-light d-flex align-items-center">
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-12 col-lg-10">
            <div className="text-center mb-5">
              <div className="mb-4">
                <img
                  src="/images/logo-text.svg"
                  alt="PowerKid"
                  style={{ height: '60px' }}
                />
              </div>
              <h1 className="display-4 fw-bold text-primary mb-3">
                {t('onboarding.welcome.title')}
              </h1>
              <p className="lead text-muted mb-4">
                {t('onboarding.welcome.subtitle')}
              </p>
              <p className="text-secondary">
                {t('onboarding.welcome.description')}
              </p>
            </div>

            <div className="row g-4 mb-5">
              {features.map((feature) => (
                <div key={feature.key} className="col-12 col-md-4">
                  <div className="card h-100 border-0 shadow-sm">
                    <div className="card-body text-center p-4">
                      <div
                        className={`rounded-circle bg-${feature.color} bg-opacity-10 d-inline-flex align-items-center justify-content-center mb-3`}
                        style={{ width: '64px', height: '64px' }}
                      >
                        <i
                          className={`bi ${feature.icon} fs-2 text-${feature.color}`}
                        />
                      </div>
                      <h5 className="card-title">
                        {t(`onboarding.welcome.features.${feature.key}.title`)}
                      </h5>
                      <p className="card-text text-muted small">
                        {t(`onboarding.welcome.features.${feature.key}.description`)}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="text-center">
              <button
                className="btn btn-primary btn-lg px-5 py-3"
                onClick={() => navigate('/family/new')}
              >
                <i className="bi bi-house-heart me-2" />
                {t('onboarding.welcome.create_family')}
              </button>
            </div>

            <div className="text-center mt-4">
              <a href="/logout" className="text-muted small">
                <i className="bi bi-box-arrow-right me-1" />
                {t('guardian.sidebar.sign_out')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomePage;
